import { Component, Input } from '@angular/core';
import { Channel, Order } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-shared-order-channel',
  templateUrl: './shared-order-channel.component.html',
  styleUrls: ['./shared-order-channel.component.scss'],
})
export class SharedOrderChannelComponent {
  @Input() order?: Order;
  @Input() show_label: boolean = true;
  on_session_channel: Channel = Channel.on_session;
  off_session_channel: Channel = Channel.off_session;

  constructor(private utils_service: UtilsService) {}

  getChannelLabel(channel?: Channel): string {
    return this.utils_service.getChannelLabel(channel);
  }
}
